import React from 'react';
import { Redirect } from 'react-router-dom'

class EnterPage extends React.Component {
	constructor(props){
		super(props);
		let id = null;
		if( props.match.params.id ){
			id = props.match.params.id;
		}
		this.props.setResultKey( id );
		this.state = {

		};
	}
	render (){
		return (
			<Redirect to="/" />
		)
	}
}

export default EnterPage;